// src/components/module/compras/components/SucursalSection.tsx
// Rediseño corporativo estilo Notion/Linear
import React, { useContext } from "react";
import { FormControl, Select, MenuItem, Typography, Box } from "@mui/material";
import { SucursalItem } from "../../../types/purchaseOrder.types";
import { DarkModeContext } from "../../../../context/darkModeContext";

const P = {
  light: { bg: "#FFFFFF", bgT: "#F1F1EF", text: "#37352F", textT: "#9B9A97", border: "#E9E9E7", borderH: "#D3D3D0", accent: "#2383E2" },
  dark: { bg: "#191919", bgT: "#2B2B2B", text: "#E8E8E6", textT: "#6B6B6B", border: "#333333", borderH: "#444444", accent: "#529CCA" },
};

interface SucursalSectionProps {
  sucursalId: number;
  sucursales: SucursalItem[];
  onSucursalChange: (sucursalId: number) => void;
}

const SucursalSection: React.FC<SucursalSectionProps> = ({ sucursalId, sucursales, onSucursalChange }) => {
  const { darkMode } = useContext(DarkModeContext);
  const p = darkMode ? P.dark : P.light;

  return (
    <Box>
      <Typography sx={{
        fontSize: "0.72rem", fontWeight: 600, color: p.textT, mb: 0.5,
        textTransform: "uppercase", letterSpacing: "0.04em",
      }}>
        Sucursal de destino
      </Typography>
      <FormControl fullWidth size="small">
        <Select
          value={sucursalId}
          onChange={(e) => onSucursalChange(Number(e.target.value))}
          sx={{
            borderRadius: "8px",
            bgcolor: p.bg,
            fontSize: "0.88rem",
            "& .MuiOutlinedInput-notchedOutline": { borderColor: p.border },
            "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: p.borderH },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: p.accent, borderWidth: "1.5px" },
          }}
        >
          {sucursales.map((s) => (
            <MenuItem key={s.Id} value={s.Id} sx={{ fontSize: "0.88rem" }}>
              {s.Nombre}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default SucursalSection;
